<div class="ftr" *ngIf="footerList.length > 0">
  <div
    class="ktmb-note"
    *ngIf="partnerCode === 'ktmb' && stepperIndex !== undefined"
  >
    <b>{{ "footer.importantNote" | translate }}</b
    >: {{ "footer.pleaseContact" | translate }}
  </div>

  <div class="ftr__container">
    <ng-container [ngSwitch]="isCustomFooterDB()">
      <!-- Custom footer -->
      <ng-container *ngSwitchCase="true">
        <ng-container [ngSwitch]="partnerCode">
          <!-- Custom footer that's not carsome -->
          <ng-container *ngIf="!isCarsomeGroup">
            <ng-container *ngSwitchDefault>
              <!-- Logo -->
              <div class="ftr__column">
                <div class="ftr__custom__logo">
                  <img
                    src="./assets/image/{{ partnerCode }}/{{
                      partnerCode
                    }}-logo.png"
                    alt=""
                  />
                  <span> {{ partnerInfo?.copyright.value }} </span>
                </div>
              </div>
              <!-- Contacts -->
              <div class="ftr__column" *ngIf="partnerInfo?.mobile.isDisplay">
                <div>
                  <img
                    class="ftr__icon"
                    src="./assets/icons/footer/whatsapp-fill.png"
                    alt=""
                  />
                  <span> {{ partnerInfo?.mobile.value }} </span>
                </div>
              </div>
              <div class="ftr__column" *ngIf="partnerInfo?.email.isDisplay">
                <div>
                  <img
                    class="ftr__icon"
                    src="./assets/icons/footer/email-fill.png"
                    alt=""
                  />
                  <span> {{ partnerInfo?.email.value }} </span>
                </div>
              </div>
            </ng-container>
          </ng-container>
          <!-- Custom carsome footer -->
          <ng-container *ngIf="isCarsomeGroup()">
            <div class="carsome__ftr">
              <div class="carsome__ftr__left">
                <img src="./assets/image/carsome/carsome-logo.png" alt="" />
                <p class="copyright-text">{{ partnerInfo?.copyright.value }}</p>
              </div>

              <mat-divider [vertical]="true"></mat-divider>

              <div class="carsome__ftr__right">
                <div class="carsome__ftr__right__question">
                  {{ "footer.haveAQuestion" | translate }}
                </div>

                <div class="carsome__ftr__right__email">
                  <div class="email-icon-container">
                    <mat-icon class="icon-display">mail_outlined</mat-icon>
                  </div>
                  <span class="email-content">
                    {{ partnerInfo?.email.value }}
                  </span>
                </div>
              </div>
            </div>
          </ng-container>

          <app-ktmb-footer *ngSwitchCase="'ktmb'" [info]="partnerInfo">
            <ng-container *ngTemplateOutlet="paymentFooter"></ng-container>
          </app-ktmb-footer>

          <app-kopetro-footer
            *ngSwitchCase="'prolindung'"
            [info]="partnerInfo"
            [socialMediaList]="socialMediaList"
          >
            <mat-divider></mat-divider>
            <ng-container *ngTemplateOutlet="paymentFooter"></ng-container>
          </app-kopetro-footer>
        </ng-container>
      </ng-container>

      <!-- Non Custom footer -->
      <ng-container *ngSwitchCase="false">
        <div class="ftr__D2C">
          <!-- Logo -->
          <div class="footer-container">
            <div class="footer-wrapper">
              <div class="footer-logo">
                <div>{{ "footer.poweredBy" | translate }}</div>
                <img
                  src="{{ _commonInfo.policystreet.logoUrl }}"
                  alt="policystreet"
                  *ngIf="partnerCode === 'ps'"
                />
                <img
                  [src]="partnerDataService?.partnerDetail?.logoUrl"
                  *ngIf="
                    partnerDataService?.partnerDetail?.logoUrl &&
                    partnerCode !== 'ps'
                  "
                  alt="partnerCode"
                  style="width: 240px"
                />
              </div>

              <div class="footer-address">
                {{ _commonInfo.policystreet.address }}
              </div>

              <div class="footer-contact">
                <img
                  src="./assets/icons/landing/whatsapp.svg"
                  alt="Whatsapp Logo"
                />
                <div>
                  {{ _commonInfo.policystreet.whatsapp }} ({{
                    "footer.whatsAppMessage" | translate
                  }})
                </div>
              </div>

              <div class="footer-contact">
                <img src="./assets/icons/landing/email.svg" alt="Email Logo" />
                <span> {{ _commonInfo.policystreet.email }} </span>
              </div>
            </div>

            <div *ngIf="partnerCode !== 'grabc'">
              <div class="footer-link" *ngFor="let footer of footerList">
                <div class="section-title">{{ footer.section | translate }}</div>

                <a [href]="section.url"
                   target="_blank"
                   *ngFor="let section of footer.sectionList">
                  {{ section.label | translate }}
                </a>
              </div>
            </div>

            <div class="social" *ngIf="partnerCode !== 'grabc'">
              <div class="ftr__heading">{{ "footer.social" | translate }}</div>
              <div class="ftr__social">
                <a
                  [href]="social.url"
                  target="_blank"
                  *ngFor="let social of socialMediaList[0].linkList"
                >
                  <img
                    [src]="social.icon"
                    [alt]="social.alt"
                    [title]="social.title"
                  />
                </a>
              </div>
            </div>
          </div>

          <mat-divider></mat-divider>
          <ng-container *ngTemplateOutlet="paymentFooter"></ng-container>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <ng-container [ngSwitch]="isCustomFooter">
    <ng-container *ngSwitchCase="false">
      <div class="ftr__bottom-d2c" [ngClass]="getFooterClasses()">
        <span>
          {{ "footer.licensed1" | translate }}
          <span>{{ _commonInfo.policystreet.regNo }}</span>
          {{ "footer.licensed2" | translate }}
        </span>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="true">
      <div class="ftr__bottom" [ngClass]="getFooterClasses()">
        <span>
          {{ "footer.licensed1" | translate }}
          <span>{{ _commonInfo.policystreet.regNo }}</span>
          {{ "footer.licensed2" | translate }}
        </span>
      </div>
    </ng-container>
  </ng-container>
</div>

<ng-template #paymentFooter>
  <div class="footer-container-2">
    <div *ngIf = "partnerCode === 'prolindung'">
      <span>{{ "footer.paymentMethod" | translate }}</span>
      <div class="payment-container2">
        <div class="payment-item" *ngFor="let payment of paymentList">
          <img
            [src]="payment.url"
            [alt]="payment.alt"
            [title]="payment.title"
          />
        </div>
      </div>
    </div>

    <div *ngIf = "partnerCode !== 'prolindung' && partnerCode !== 'grabc'">
      <span>{{ "footer.paymentMethod" | translate }}</span>
      <div class="payment-container">
        <div class="payment-item" *ngFor="let payment of paymentList">
          <img
            [src]="payment.url"
            [alt]="payment.alt"
            [title]="payment.title"
          />
        </div>
      </div>
    </div>

    <div *ngIf="partnerCode !== 'prolindung' && partnerCode !== 'grabc'">
      <span>
        {{
          (partnerCode === "ktmb"
            ? "footer.acceptedEppBanks"
            : "footer.banksForZeroEpp"
          ) | translate
        }}
      </span>
      <div class="payment-container">
        <div class="payment-item" *ngFor="let bank of bankList">
          <img [src]="bank.url" [alt]="bank.alt" [title]="bank.title" />
        </div>
      </div>
    </div>
  </div>
</ng-template>
